import RecipeValidator from 'domain/recipe/usecases/validator';

const validateRecipe = (recipe) => {
  const recipeKeys = Object.keys(RecipeValidator);

  const errors = {};
  for (const key of recipeKeys) {
    const errorMessage = RecipeValidator[key](recipe[key]);
    if (errorMessage) errors[key] = errorMessage;
  }

  if (!Object.keys(errors).length) return null;
  return errors;
};

export default validateRecipe;
